import {
	ChangeDetectionStrategy,
	Component,
	inject,
	input,
	OnInit,
	signal,
} from '@angular/core';
import { StorageService } from '@context/frontend/storage';
import { ContentLog } from '@context/shared/types/log';
import { getPreferredThumbnail } from '@context/shared/types/media';
import { TuiSizeXL } from '@taiga-ui/core';
import { TuiAvatar } from '@taiga-ui/kit';

@Component({
	imports: [TuiAvatar],
	selector: 'ctx-log-thumbnail',
	templateUrl: 'log-thumbnail.component.html',
	styleUrl: 'log-thumbnail.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogThumbnailComponent implements OnInit {
	readonly log = input.required<ContentLog>();

	readonly size = input<TuiSizeXL>('l');

	readonly storageService = inject(StorageService);

	readonly thumbnailUrl = signal<string | null>(null);

	async ngOnInit() {
		const res = await this.fetchThumbnail();
		this.thumbnailUrl.set(res);
	}

	fetchThumbnail() {
		const log = this.log();
		if (!log.thumbnails?.length) return Promise.resolve(null);

		const thumbnail = getPreferredThumbnail(log.thumbnails, {
			resolution: 256,
		});

		if (!thumbnail) return Promise.resolve(null);

		const storagePath = this.storageService.getReference(
			thumbnail.storagePath,
		);
		return this.storageService.getDownloadUrl(storagePath);
	}
}
